import { RootState } from "./rootReducer";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  userId: '',
};

export const enrollmentAutthorizationReducer = createSlice({
  name: "EnrollmentAutthorizationReducer",
  initialState,
  reducers: {
    saveAutthorization: (state, action: PayloadAction<{ userId: string}>) => {
      return action.payload;
    },
    resetAutthorization: () => {
      return initialState;
    },
  },
});

export const { resetAutthorization, saveAutthorization } = enrollmentAutthorizationReducer.actions;

export const getEnrollmentAutthorizationRedux = (state: RootState) => { return state };

export const getEnrollmentAutthorizationUserId = (state: RootState) => { return state.enrollmentAutthorizationReducer.userId };

export default enrollmentAutthorizationReducer.reducer;
